import { Box, List, Paper } from '@mui/material';

import { CardItem, CategoryWithItems } from './CardTab';
import CardItemLine from './CardItem';
import CategoryHeader from '@src/components/category/CategoryHeader';
import { useMemo } from 'react';

interface Props {
  category: CategoryWithItems;
  isShowChanges: boolean;
}

function CardCategory({ category, isShowChanges }: Props) {
  const groupedItems = useMemo(() => {
    const groupedMap = category.items.reduce<Record<string, CardItem[]>>(
      (acc, item) => {
        const groupKey = item.type === 'Item' ? item.id : item.entityId;

        if (!acc[groupKey]) {
          acc[groupKey] = [];
        }

        acc[groupKey].push(item);
        return acc;
      },
      {}
    );

    return Object.entries(groupedMap).map(([groupKey, items]) => ({
      groupKey,
      items,
    }));
  }, [category.items]);

  return (
    <Paper
      sx={(theme) => ({
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
      })}>
      <Box
        sx={(theme) => ({
          borderBottom: '1px solid rgba(230, 231, 233, 1)',
          padding: theme.spacing(2),
        })}>
        <CategoryHeader name={category.name} count={category.items.length} />
      </Box>
      <List>
        {groupedItems &&
          groupedItems.map((group) =>
            group.items.map((i) => (
              <CardItemLine cardItem={i} isShowChanges={isShowChanges} />
            ))
          )}
      </List>
    </Paper>
  );
}

export default CardCategory;
